import React from 'react';

import LogoDark from '@assets/images/logo_dark.svg';
import LogoLight from '@assets/images/logo_light.svg';

import { SocialIcons } from '../SocialIcons/SocialIcons';
interface FooterLinksProps {
  theme: 'dark' | 'light';
}

export function FooterLinks({ theme, ...rest }: FooterLinksProps) {
  const footerClassname =
    theme === 'dark'
      ? 'betterMood__footerLinks betterMood__theme-dark'
      : 'betterMood__footerLinks betterMood__theme-light';

  return (
    <>
      <ul className="betterMood__footerLogo">
        <li>
          <a href="/" title="Bettter Mood">
            <img
              src={theme === 'dark' ? LogoLight : LogoDark}
              alt="Better Mood"
              height="33"
              width="90"
            />
          </a>
        </li>
      </ul>

      <div className={footerClassname}>
        <ul>
          <li>Company</li>
          <li>
            <a
              href="/frequently-asked-questions/"
              title="Frequently Asked Questions">
              FAQ
            </a>
          </li>
          <li>
            <a href="/contact-us/" title="Contact Us">
              Contact Us
            </a>
          </li>
        </ul>

        <ul>
          <li>Legal</li>
          <li>
            <a href="/privacy-policy/" title="Privacy Policy">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="/terms-of-service/" title="Terms of Use">
              Terms of Use
            </a>
          </li>
        </ul>

        <ul>
          <li>For Members</li>
          <li>
            <a href="/app/login" title="Access your plan here">
              Access Plan
            </a>
          </li>
          <li>
            <a href="/app/" title="Member's area login">
              Login
            </a>
          </li>
          <li>
            <a href="/contact-us/" title="Contact our support team">
              Support
            </a>
          </li>
        </ul>
        <ul>
          <li>Follow us</li>
          <li>
            <SocialIcons light={theme === 'dark'} dark={theme === 'light'} />
          </li>
        </ul>
      </div>
    </>
  );
}
